import { getHostName } from '../../../utils/browserUtils';
import { ADD_LOADED_COMPONENT } from './constants';

const initialState = {
  loadedComponents: [],
};

export default (state = initialState, action) => {
  if (getHostName().includes('holidaysexpert')) {
    return state;
  }

  switch (action.type) {
    case ADD_LOADED_COMPONENT:
      return {
        ...state,
        loadedComponents: [...state.loadedComponents, action.payload],
      };
    default:
      return state;
  }
};
